import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AgentService} from '../../shared/services/agent.service';
import { environment } from 'src/environments/environment';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TopbarComponent } from '../../shared/components/topbar/topbar.component';
import { SidebarComponent } from '../../shared/components/sidebar/sidebar.component';
import { BottombarComponent } from '../../shared/components/bottombar/bottombar.component';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'app-agent-details',
    templateUrl: './agent-details.component.html',
    styleUrls: ['./agent-details.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        RouterModule,
        NgxPaginationModule,
        TopbarComponent,
        SidebarComponent,
        BottombarComponent
    ]
})
export class AgentDetailsComponent implements OnInit {
id;
data;
  transactions;
  config: any;
  constructor(private route: ActivatedRoute, private agentService: AgentService) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      const slug = params.get('slug');
      this.getAgent(slug);
      this.getTransaction(slug);
    });
  }

  getAgent(id) {
    if(environment.production){
    this.agentService.getAgent(id).subscribe(
      data => this.data = data
    );
  }else{
     this.agentService.getTestAgent(id).subscribe(
      data => this.data = data
    );
  }
  }
  
  getTransaction(agentId) {
    this.agentService.getAgentTransaction(agentId).subscribe(
      data => {
        this.transactions = data;
        this.config = {
          itemsPerPage: 10,
          currentPage: 1,
          totalItems: this.transactions.length
        };
      }
    );
  }


  pageChanged(event) {
    this.config.currentPage = event;
  }

}
